/**
 * Marketing site constants.
 *
 * The public marketing website (separate from the app origin) — the language
 * path (`/en`, `/pl`) is appended at runtime based on the active UI language.
 */

/** Public marketing website base URL (language path appended at runtime). */
const MARKETING_SITE_BASE_URL = 'https://www.geomarkup.com';

/** Marketing-site language path segment (the only two supported UI languages). */
export type MarketingLanguage = 'pl' | 'en';

/**
 * Normalize a raw i18n language tag (e.g. `"pl-PL"`) to a marketing-site
 * language. Anything that isn't Polish falls back to English.
 */
function resolveMarketingLanguage(language: string): MarketingLanguage {
  return language.startsWith('pl') ? 'pl' : 'en';
}

/**
 * Build a language-prefixed marketing-site URL. `path` is appended after the
 * language segment and should start with `/` (or be empty for the language root).
 */
export function buildMarketingUrl(language: string, path = ''): string {
  return `${MARKETING_SITE_BASE_URL}/${resolveMarketingLanguage(language)}${path}`;
}
